module.exports = __webpack_public_path__ + "img/map_h5.72af84a8.png";